import React, { useState } from "react";
import Chevron from "../../../assets/images/common/chevron-right.svg";
import "../../../assets/css/laboratory/bloodtest/bloodtest.scss";
import AddTestModal from "../../../components/laboratory/bloodtest/AddTestModal";
import LaboratoryWrapper from "../../../components/common/LaboratoryWrapper";
import labTestIcon from "../../../assets/images/common/lab.svg";


const BloodTest = () => {
  const rows = [
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
  ];

  const [showAddTestModal, setshowAddTestModal] = useState(false);

  const handleAddTestModal = () => {
    setshowAddTestModal(true);
  };

  return (
    <>
      <AddTestModal
        open={showAddTestModal}
        onClose={() => setshowAddTestModal(false)}
      />

      <div className="row mb-lg-5 mb-4 pb-5 px-3  pt-4 bloodtest-tab">
        <div className="col-12">
          <p className="mb-0 bloodtest-heading">Blood Test</p>
        </div>

        <div className="col-12 my-4">
          <div className="row ">
            <div className="col-md-6 ">
              <p className="bloodtest-breadcrumb">
                <span>DASHBOARD</span>
                <img src={Chevron} />
                <span> LABORATORY </span>
                <img src={Chevron} />
                <span className="current-tab"> BLOOD TEST</span>
              </p>
            </div>
            <div class="col-md-6 text-md-right ">
              <button
                type="button"
                class="add-test"
                onClick={handleAddTestModal}
              >
                Add Test
              </button>
            </div>
          </div>
        </div>

        <LaboratoryWrapper
          title="Test Details"
          requestSectionTitle="Test Appointments"
          rows={rows}
          icon={labTestIcon}
        />
      </div>
    </>
  );
};

export default BloodTest;
